<template>
  <div class="FinancesInvoicesExtraPaymentsTable">
    <b-table :fields="fields" :items="items">
      <template #cell(cost)="{ item, index }">
        <div>
          <b-form-input
            type="number"
            no-wheel
            v-model="item.cost"
            @input="dataTouched(index, 'cost')"
          />
          <span class="currency-code">{{ currencyCode }}</span>
        </div>
        <div class="row sales-commission-block">
          <b-form-checkbox
            size="md"
            :id="'sales-commission-' + index"
            switch
            disabled
            :checked="!!item.sales_commission_percent"
            class="switch"
            @click.native="checkSalesCommission(item)"
            :value="true"
          />
          <b-form-select
            size="sm"
            class="col-7"
            v-show="!!item.sales_commission_percent"
            v-model="item.sales_commission_percent"
            :options="salesCommissionOptions"
          />
        </div>
        <div class="row">
          <div class="col">
            <label :for="'sales-commission-' + index">Eligible for sales commission</label>
          </div>
        </div>
      </template>
      <template #cell(description)="{ item, index }">
        <b-form-textarea
          id="textarea"
          v-model="item.description"
          rows="3"
          max-rows="6"
          @input="dataTouched(index, 'description')"
        >
        </b-form-textarea>
      </template>
      <template #cell(actions)="data" v-if="items.length >= 1">
       <b-button variant="danger" size="sm" @click.prevent="removeItem(data)">
         <font-awesome-icon icon="trash" />
       </b-button>
      </template>
    </b-table>
    <b-button @click.prevent="addItem" variant="info">
      Add payment
    </b-button>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

const defaultItem = {
  'cost': null,
  'description': null,
  'sales_commission_percent': null
}

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    currencyCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fields: [
        { key: 'cost', label: 'Cost', class: 'cost-column' },
        { key: 'description', label: 'Description', class: 'description-column' },
        { key: 'actions', label: '', class: 'actions-column' }
      ],
      items: [],
      salesCommissionOptions: [2.5, 5]
    }
  },
  mounted () {
    this.setInitialParams()
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        this.setInitialParams()
      }
    }
  },
  methods: {
    setInitialParams () {
      this.items = this.value || []
      this.triggerInputEmit()
    },
    addItem () {
      this.items.push(cloneDeep(defaultItem))
      this.triggerInputEmit()
    },
    removeItem (data) {
      const removedIndex = data.index
      this.items = this.items.filter((item, index) => index !== removedIndex)
      this.dataTouched(data.index, null)
      this.triggerInputEmit()
      this.$emit('dataRemoved', { removedIndex })
    },
    triggerInputEmit () {
      this.$emit('input', this.items)
    },
    dataTouched (index, attrName) {
      this.$emit('dataTouched', { index, attrName })
    },
    checkSalesCommission (item) {
      if (!item.sales_commission_percent) {
        item.sales_commission_percent = this.salesCommissionOptions[0]
      } else {
        item.sales_commission_percent = null
      }
    }
  }
}
</script>

<style lang="scss">
  .FinancesInvoicesExtraPaymentsTable{
    margin-bottom: 1rem;
    .actions-column {
      min-width: 40px;
    }
    .cost-column {
      width: 120px;
    }
    .description-column {
      width: auto;
    }
    .currency-code {
      float: right;
      margin-top: -28px;
      margin-right: 4px;
    }
    .sales-commission-block {
      display: flex;
      align-items: center;
      margin: 5px -2px 5px 1px;
    }
  }
</style>
